import { combineReducers } from '@reduxjs/toolkit'

// Placeholder reducer - can be removed when actual reducers are added
const placeholderReducer = (state = {}) => state

export default combineReducers({
  placeholder: placeholderReducer
  // Add reducers here as needed
})
